import Grid from "@mui/material/Unstable_Grid2";
import BranchList from "../components/BranchList";
import Map from "../components/GoogleMap";
import { Box, Stack } from "@mui/material";
import InitSearchAlert from "../ui/InitSearchAlert";
import { Pagination } from "@mui/lab";
import { useState } from "react";
import BranchListSkeleton from "../ui/BranchListSkeleton";

const Body = ({ branches, loading, dataPerPage }) => {
  const [page, setPage] = useState(1);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const maxPage = Math.ceil(branches.length / dataPerPage);

  const pagedBranches = branches.slice(
    (page - 1) * dataPerPage,
    page * dataPerPage
  );

  return (
    <Grid container spacing={2}>
      <Grid xs={12} md={8} sx={{ order: { xs: 2, md: 1 } }}>
        <Stack spacing={2}>
          {loading && <BranchListSkeleton />}
          {!loading && <BranchList branches={pagedBranches} />}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Pagination
              color="primary"
              count={maxPage}
              page={page}
              onChange={handlePageChange}
            />
          </Box>
        </Stack>
      </Grid>
      <Grid xs={12} md={4} sx={{ order: { xs: 1, md: 2 } }}>
        <Map branches={branches} />
      </Grid>
    </Grid>
  );
};

export default Body;
